import { useApi } from './useApi';
import { apiService } from '../services/api';

interface OverOnsHeroData {
  id: number;
  documentId: string;
  title: string;
  backgroundMedia?: {
    id: number;
    url: string;
    alternativeText?: string;
    width: number;
    height: number;
    formats?: {
      thumbnail?: { url: string; width: number; height: number; };
      small?: { url: string; width: number; height: number; };
      medium?: { url: string; width: number; height: number; };
      large?: { url: string; width: number; height: number; };
    };
  };
  mediaType?: 'image' | 'video';
  videoUrl?: string;
  overlayOpacity?: number;
  textColor?: 'white' | 'black';
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useOverOnsHero() {
  return useApi<OverOnsHeroData>(apiService.getOverOnsHero);
} 